<template>
  <div>
    <div class="kt-portlet kt-portlet--responsive-mobile permissions-portlet">
      <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="la la-lock" />
          </span>
          <h3 class="kt-portlet__head-title">
            Permissions <small v-if="user.is_admin" class="hidden-xs"><i class="la la-star" />{{ user.name }} is an Admin</small>
          </h3>
        </div>
        <div class="kt-portlet__head-toolbar">
          <div class="btn-group">
            <button type="button" class="btn btn-secondary dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
              Actions
            </button>
            <div class="dropdown-menu dropdown-menu-right">
              <a class="dropdown-item" href="javascript;" @click.prevent="save">
                <i class="la la-save" />Save Permissions
              </a>
              <button type="button" class="dropdown-item"
                      title="Save as Role"
                      @click="saveRole">
                <i class="la la-user-secret" /> Save as Role
              </button>
              <a v-if="user.is_admin" class="dropdown-item"
                 href="javascript;" @click.prevent="toggleAdmin(0)">
                <i class="la la-close" /> Remove Admin
              </a>
              <a v-else class="dropdown-item"
                 href="javascript;"
                 @click.prevent="toggleAdmin(1)">
                <i class="la la-star" /> Make Admin</a>

              <div v-if="roles.length">
                <div class="dropdown-divider" />
                <h6 class="dropdown-header">
                  Roles
                </h6>
                <div class="dropdown-divider" />
                <div class="roles">
                  <table class="table table-striped kt-table">
                    <tr v-for="(role, index) in roles" :key="index"
                        class="role-actions">
                      <td class="cursor-pointer"
                          @click.prevent="applyRole(role)">
                        {{ role.label }}
                      </td>
                      <td @click.prevent="applyRole(role)">
                        <button type="button" class="btn btn-secondary">
                          Apply
                        </button>
                      </td>
                      <td @click.prevent="deleteRole(role)">
                        <button type="button" class="btn btn-ss-danger btn-icon btn-sm">
                          <i class="la la-trash" />
                        </button>
                      </td>
                    </tr>
                  </table>
                </div>
                <p v-if="roles.length && roles.length > 2"
                   class="text-center">
                  Scroll <i class="fa fa-chevron-down" />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="row">
          <div class="col-12 col-md-6">
            <span>
              <label>General Permissions </label>
              <span class="tree-loader kt-spinner kt-spinner--warning ml-2" />
            </span>

            <div class="alert alert-ss-primary fade show">
              <p>
                <span class="kt-badge kt-badge--inline kt-badge--success">API</span> Refers to a specific action in the system, it is not limited to API requests.<br>
                <span class="kt-badge kt-badge--inline kt-badge--info">Page</span> Refers to the page view itself, not a specific action.<br>
                Toggle the root level to disable an entire feature.
              </p>
            </div>

            <div id="permissions-tree" />
          </div>

          <div v-if="user.customer.api_access && authenticated_user.is_admin" class="col-12 col-md-6">
            <label>Api Access</label>
            <div class="input-group kt-input-group kt-input-group--square">
              <div class="input-group-prepend">
                <span class="input-group-text"><i
                  class="la la-lightbulb-o" /></span>
              </div>
              <select v-model="user.api_access"
                      class="dropdown-square form-control kt-input" name="api_access">
                <option value="1">
                  Enabled
                </option>
                <option value="0">
                  Disabled
                </option>
              </select>
            </div>
            <span class="kt-form__help" />
          </div>
        </div>
      </div>
      <div class="kt-portlet__foot">
        <div class="row align-items-center">
          <div class="col-lg-12">
            <button class="btn btn-ss-standout" @click.prevent="save">
              <i class="la la-save" /> Save Permissions
            </button>
          </div>
        </div>
      </div>
      <save-role-modal />
    </div>
  </div>
</template>

<script>
import SaveRoleModal from 'VuePartials/Admin/VJSModals/SaveRoleModal';

export default {
  name: "Tree",
  components: {
    SaveRoleModal,
  },
  props: {
    featureActionData: {
      type: [Object, Array],
      default() {
        return null;
      },
    },
  },
  data: () => ({
    the_tree: {},
    roles: [],
    roleName: "",
    user: window.user,
    authenticated_user: window.authenticated_user,
  }),
  computed: {
    styled_tree_data() {
      const data = [];
      _.forEach(this.featureActionData, (restriction) => {
        if (restriction.api && restriction.parent !== '#') {
          restriction.text = `<span>${restriction.text}</span><span class="kt-badge kt-badge--inline kt-badge--success">API</span>`;
        } else if (!restriction.api && restriction.parent !== '#') {
          restriction.text = `<span>${restriction.text}</span><span class="kt-badge kt-badge--inline kt-badge--info">Page</span>`;
        }
        data.push(restriction);
      });
      return data;
    },
    can_edit_user() {
      return !this.authenticated_user.is_admin ||
        this.authenticated_user.is_organisation_admin && this.user.is_super_admin ||
        this.authenticated_user.is_admin && this.user.is_organisation_admin;
    },
  },
  watch: {
    featureActionData: function () {
      this.populateTree();
    },
  },
  mounted() {
    this.getRoles();
  },
  methods: {
    save() {
      // Get tree as json
      const v = $("#permissions-tree")
        .jstree(true)
        .get_json("#", { flat: true });

      const data = JSON.stringify(v);
      axios
        .post(`/permissions/${window.user.uuid}/store`, {
          data: data,
          api_access: window.user.api_access,
        })
        .then((response) => {
          if (response.data.success) {
            toastr.success("Permissions Saved");
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            toastr.error(
              "You are not authorised to save permissions",
            );
          }
          if (error.response.data.error) {
            toastr.error("Unable to Save. Please try again later.");
          }
        });
    },
    async saveRole() {
      const res = await this.fireModal(`save-as-role`);
      if (res.data.confirm) {
        const v = $("#permissions-tree")
          .jstree(true)
          .get_json("#", { flat: true });
        const data = JSON.stringify(v);
        try {
          const api_res = await axios.post(`/api/v1/user/roles/${window.user.uuid}/store`, {
            permissions: data,
            roleName: res.data.role_name,
          });
          toastr.success(`Role Saved`);
          this.roles.push(api_res.data.data);
        } catch (err) {
          console.error(err);
          toastr.error(`Unable to save. Please try again later.`);
        }
      }
    },
    deleteRole(role, index) {
      axios
        .delete(`/api/v1/user/roles/${role.id}/destroy`, {})
        .then(() => {
          toastr.success("Role Deleted.");
          this.roles.splice(index, 1);
        })
        .catch(() => {
          toastr.error("Unable to delete role. Try again later.");
        });
    },
    getRoles() {
      // Get tree as json
      axios
        .get(`/api/v1/user/roles/${window.user.uuid}/show`, {})
        .then((response) => {
          this.roles = response.data.data;
        })
        .catch(() => {
          toastr.error(
            "Unable to load roles. Please try again later.",
          );
        });
    },
    applyRole(role) {
      const permissions = JSON.parse(role.data);
      // Reset tree permissions
      this.checkAll();

      const selected_ids = [];

      // Based on the role clicked add the ids that should be deselected to the array
      if (permissions["restricted_actions"]) {
        for (const key in permissions["restricted_actions"]) {
          if (Object.prototype.hasOwnProperty.call(permissions["restricted_actions"], key)) {
            selected_ids.push(
              permissions["restricted_actions"][key],
            );
          }
        }
        for (const key in permissions["restricted_features"]) {
          if (Object.prototype.hasOwnProperty.call(permissions["restricted_features"], key)) {
            selected_ids.push(
              permissions["restricted_features"][key],
            );
          }
        }
      }

      // Perform deselect
      $("#permissions-tree")
        .jstree(true)
        .deselect_node(selected_ids);
    },
    uncheckAll() {
      $("#permissions-tree").jstree("deselect_all");
    },
    checkAll() {
      $("#permissions-tree").jstree("select_all");
    },
    toggleAdmin(is_admin) {
      axios
        .patch(`/api/v1/user/roles/${window.user.uuid}/isAdmin`, {
          isAdmin: is_admin,
        })
        .then(() => {
          if (is_admin) {
            toastr.success(window.user.name + " is now an admin");
          } else {
            toastr.success(window.user.name + " is no longer an admin");
          }
          this.user.is_admin = is_admin;
        })
        .catch(() => {
          toastr.error(
            "Unable to change admin privileges. Please try again later.",
          );
        });
    },
    populateTree() {
      const vm = this;
      this.the_tree = $("#permissions-tree").jstree({
        core: {
          animation: 200,
          expand_selected_onload: false,
          expand_undetermined_onload: true,
          check_callback: true,
          themes: { responsive: true },
          data: vm.styled_tree_data,
        },
        types: {
          "#": {
            max_children: 1,
            max_depth: 4,
            valid_children: ["root"],
          },
          default: {
            valid_children: ["default", "file"],
          },
          file: {
            icon: "fa fa-cogs",
            valid_children: [],
          },
        },
        plugins: ["wholerow", "checkbox", "types"],
      });
      $(".tree-loader").hide();
    },
  },
};
</script>

<style lang="scss">
  .jstree-anchor {
    .kt-badge.kt-badge--inline {
      margin-left:1em !important;
      padding: 0 0.25rem !important;
      line-height:15px;
    }
  }
</style>

<style scoped lang='scss'>
  @use "~AssetsSass/_variables.scss" as *;

  .permissions-portlet {
    margin-bottom: 100px;
  }

  @media (min-width: 768px) {
    .modal-dialog {
      width: 350px;
    }
  }

  .roles {
    padding: 0 15px 0 15px;
    max-height: 150px;
    overflow: scroll;

    tr {
      td {
        padding: 0.5rem 0.75rem 0.5rem 0.75rem;
        vertical-align: middle;
      }

      td:first-child {
        min-width: 150px;
        padding-left: 0;
      }

      td:last-child {
        padding-left: 0;
        padding-right: 0;
      }
    }

    tr:first-child {
      td {
        border-top: none;
      }
    }
  }
</style>
